const home = "/";
const search = "/search";
const accountBaseRoute = `/my-account`;
const cart = "/cart";
const checkout = "/checkout";
const events = "/events";
const eventTerms = "/events-terms-conditions";

const Routes = {
    home,
    search,
    accountBaseRoute,
    cart,
    checkout,
    events,
    eventTerms,
    checkoutSuccess: `${checkout}/success`,
    oktaCallback: "/login/callback",
    login: `${accountBaseRoute}/login`,
    register: `${accountBaseRoute}/signup`,
    forgotPassword: `${accountBaseRoute}/forgot-password`,
    resetPassword: `${accountBaseRoute}/reset-password`,
    editProfile: `${accountBaseRoute}/edit`,
    currentMembership: `${accountBaseRoute}/clubs`,
    expiredMembership: `${accountBaseRoute}/clubs/expired`,
    managedEvents: `${accountBaseRoute}/managed-events`,
    managedEvent: `${accountBaseRoute}/managed-event`,
    incomingTickets: `${accountBaseRoute}/tickets`,
    pastTickets: `${accountBaseRoute}/tickets/past`,
    purchases: `${accountBaseRoute}/purchases`,
    manageClubs: `${accountBaseRoute}/manage-clubs`,
    manageEvent: `${accountBaseRoute}/manage-event`,
    eapLanding: `${accountBaseRoute}/eap`,
    eapBenefits: `${accountBaseRoute}/eap/your-scholarship`,
    logout: `${accountBaseRoute}/logout`,
};

export default Routes;
